import styled from '@emotion/styled';
import { grid, enlargedInputFieldHeight, inputFieldHeight } from '../style-utils';
import { N500, N50A, N60A } from '@atlaskit/theme/colors';
import { ClearIconWrapper, DesktopSearchIconWrapper, SearchInputField } from './search-input.styled';

// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const EnlargedDesktopSearchIconWrapper = styled(DesktopSearchIconWrapper)`
	width: ${props => props.isExpanded ? enlargedInputFieldHeight.half().px : grid.multiple(2).px};
	height: ${props => props.isExpanded ? enlargedInputFieldHeight.half().px : grid.multiple(2).px};
	top: ${props => props.isExpanded ? grid.multiple(1.5).px : grid.px};
	left: ${props => props.isExpanded ? grid.multiple(2).px : grid.px};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const EnlargedClearIconWrapper = styled(ClearIconWrapper)`
	width: ${"var(--ds-space-300, 24px)"};
	height: ${"var(--ds-space-300, 24px)"};
	padding-top: 0;
	padding-bottom: 0;
	padding-left: ${({
  isExpanded
}) => isExpanded ? `${"var(--ds-space-150, 12px)"}` : '0'};
	padding-right: ${({
  isExpanded
}) => isExpanded ? `${"var(--ds-space-200, 16px)"}` : '2px'};
	color: ${`var(--ds-text-subtle, ${N500})`};
`;

// FIXME: convert-props-syntax rule doesn't catch this
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const EnlargedSearchInputField = styled(SearchInputField)`
	display: flex;
	align-items: center;

	height: ${props => props.isExpanded ? enlargedInputFieldHeight.px : inputFieldHeight.px};

	border-radius: ${props => props.isExpanded ? '8px' : '5px'};

	padding: ${props => props.isExpanded ? `${"var(--ds-space-150, 12px)"} 52px ${"var(--ds-space-150, 12px)"} 52px` : `0px ${"var(--ds-space-300, 24px)"} 0px 30px`};

	:focus {
		border: none;

		box-shadow: ${`var(--ds-shadow-overlay, ${'0 ' + grid.multiple(0.5).px + ' ' + grid.px + ' ' + N50A + ', 0 0 1px ' + N60A})`};
	}
`;